module.exports = __webpack_public_path__ + "img/logo_u1992-8.92e6dfc4.svg";